import { BasicSocialData } from '@goodgamestudios/core';

import { ExternalInterface } from "@goodgamestudios/createjs-utilities";

export class Poker2SocialData extends BasicSocialData {
    //TODO den Fashion Kramm entfernen, pruefen ob die Methoden noch gebraucht werden
    public static EXTERNAL_SHARE_LEVELUP: string = "postLevelUpFeed";
    public static EXTERNAL_SHARE_EXPAND: string = "postExpand";
    public static EXTERNAL_SHARE_ACHIEVEMENT: string = "postAchievementFeed";
    public static EXTERNAL_SHARE_GIFTS: string = "postNewGiftFeed";
    public static EXTERNAL_SHARE_FIND_TIP: string = "postGotTipFeed";

    constructor() {
        super();
    }
    public postFeed(type: string, params: any[] = null): void {
        this.externalInterface(type, params);
    }
    protected externalInterface(type: string, params: any[] = null): void {
        super.externalInterface(type, params);
        if (!ExternalInterface.available)
            return;
        try {
            switch (type) {
                case "postExpand":
                    ExternalInterface.call(type);
                    break;
                default:
                    if (params)
                        ExternalInterface.call(type, params[0]);
                    break;
            }
        }
        catch (error) {
        }
    }
}
